module.exports =
  reroute: '/orderform/reroute'
  thirdParty:
    mww:
      wrongAddress: '/orderform/thirdparty/mww/invalid/address'
      validateAddress: '/orderform/thirdparty/mww/address/validate'
      fixOrderFormAddress: '/orderform/thirdparty/mww/fixaddress'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/orderForm.coffee